var _path, _rect, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountCardBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 124,
    viewBox: "0 0 202 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6391_340898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: -51,
    width: 237,
    height: 288
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.269 -17.9606C92.5699 -37.9017 101.073 -50.3116 116.917 -50.6347C128.885 -50.8768 138.284 -44.3721 146.184 -35.3836C154.13 -26.3429 158.555 -16.138 168.777 -9.91831C176.116 -5.45507 192.256 -2.98435 200.219 0.23028C207.004 2.96942 213.077 9.80035 215.912 17.9079C219.349 27.7425 216.588 38.6568 213.862 48.7169C210.022 62.8959 210.98 72.8407 215.791 84.427C221.938 99.2118 235.543 112.591 242.948 126.785C250.353 140.98 253.494 159.514 243.761 172.237C229.407 190.998 196.088 186.625 183.311 206.492C180.026 211.596 178.647 217.658 176.285 223.251C173.924 228.845 170.058 234.39 164.222 236.077C158.206 237.818 151.832 234.985 146.649 231.477C141.467 227.97 136.641 223.64 130.65 221.818C119.724 218.494 108.216 224.311 96.7944 224.584C79.259 225.005 62.715 210.219 61.18 192.756C60.318 182.968 63.5984 173.33 64.5972 163.555C67.1292 138.767 55.6413 109.556 43.4645 87.8214C31.2877 66.0864 16.6146 44.3584 13.4036 26.0858C11.989 18.0336 14.9709 10.2346 18.0777 5.69492C21.6906 0.411698 28.5738 -3.31582 34.8997 -4.30062C39.1471 -4.96524 45.6935 -5.58943 49.952 -4.98721C56.432 -4.07094 63.1634 -3.96454 69.3861 -5.99778C75.6102 -8.02599 81.2773 -12.4338 83.6721 -18.5259L83.269 -17.9606Z",
    fill: "url(#paint0_linear_6391_340898)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6391_340898)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6391_340898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: -4,
    width: 205,
    height: 116
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -3.66663,
    width: 205,
    height: 114.8,
    fill: "url(#paint1_linear_6391_340898)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6391_340898)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6391_340898)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9155 27.6396C58.5481 26.3877 57.398 25.4729 56.0282 25.4729C55.2042 25.4729 54.4558 25.8065 53.9134 26.343C53.3915 24.9536 52.0526 23.9632 50.4802 23.9632C50.3944 23.9632 50.3086 23.9666 50.2227 23.9735C49.155 22.646 47.5174 21.7965 45.6841 21.7965C43.5487 21.7965 41.6845 22.9452 40.6683 24.6613C40.0091 22.983 38.3784 21.7965 36.4696 21.7965C34.6946 21.7965 33.16 22.8214 32.4253 24.3139C31.7421 21.6211 29.308 19.6299 26.4104 19.6299C23.5129 19.6299 21.0925 21.6074 20.4024 24.2864C19.8051 23.7431 19.0086 23.4095 18.1366 23.4095C17.0174 23.4095 16.0217 23.9563 15.4106 24.7989C14.7961 23.9563 13.8039 23.4095 12.6847 23.4095C11.5655 23.4095 10.6145 23.9391 10 24.7507V27.6396H58.9155Z",
    fill: "url(#paint2_linear_6391_340898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215 47.8443C213.939 46.7198 212.435 46.0216 210.77 46.0216C208.635 46.0216 206.771 47.1703 205.755 48.8864C205.095 47.2081 203.465 46.0216 201.556 46.0216C199.781 46.0216 198.246 47.0465 197.512 48.539C196.828 45.8462 194.394 43.855 191.497 43.855C188.599 43.855 186.179 45.8325 185.489 48.5115C184.891 47.9682 184.095 47.6346 183.223 47.6346C182.104 47.6346 181.108 48.1814 180.497 49.024C179.882 48.1814 178.89 47.6346 177.771 47.6346C176.26 47.6346 174.98 48.6285 174.551 50.0007C174.228 49.8081 173.85 49.6946 173.445 49.6946C172.566 49.6946 171.814 50.2208 171.475 50.9739C170.991 50.4237 170.287 50.0729 169.497 50.0729C168.34 50.0729 167.358 50.8226 167.005 51.8612H215.003V47.8443H215Z",
    fill: "url(#paint3_linear_6391_340898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.748 10.4406C180.092 9.02021 178.657 8.03319 176.992 8.03319C175.763 8.03319 174.657 8.56969 173.902 9.42603C173.006 8.06414 171.468 7.16653 169.72 7.16653C167.973 7.16653 166.541 8.00224 165.635 9.28502C165.216 6.94299 163.17 5.16153 160.712 5.16153C159.895 5.16153 159.126 5.35756 158.446 5.70491C157.244 3.50732 154.917 2.01819 152.239 2.01819C149.561 2.01819 147.357 3.43166 146.128 5.5364C145.249 1.94597 142.015 -0.722778 138.156 -0.722778C135.276 -0.722778 132.742 0.766355 131.276 3.01553C130.48 2.67506 129.601 2.48591 128.681 2.48591C125.508 2.48591 122.858 4.72477 122.223 7.71335C121.327 5.95941 119.507 4.75572 117.406 4.75572C115.154 4.75572 113.225 6.1348 112.411 8.09509C111.951 7.72367 111.371 7.50013 110.732 7.50013C109.259 7.50013 108.065 8.69694 108.065 10.1723C108.065 10.1826 108.065 10.1929 108.065 10.2033C107.254 8.74852 105.706 7.76838 103.924 7.76838C102.05 7.76838 100.429 8.85857 99.6602 10.4406H180.748Z",
    fill: "url(#paint4_linear_6391_340898)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0257 -3.66663L91.9011 17.8691H86.7686L87.644 -3.66663H91.0257Z",
    fill: "#D3E6F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.613 41.1862L124.784 46.0387L125.687 53.113L184.613 42.4689V41.1862Z",
    fill: "#D3E6F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.784 59.5304L215 55.9744V62.12L119.428 73.1321L124.784 59.5304Z",
    fill: "#D3E6F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 42.4758L53.9134 46.0387L53.0104 53.113L10 45.344V42.4758Z",
    fill: "#D3E6F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9134 59.5304L10 57.8005V67.4541L59.2691 73.1321L53.9134 59.5304Z",
    fill: "#D3E6F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.694 96.2257C192.385 96.2257 200.241 88.3561 200.241 78.6484C200.241 68.9408 192.385 61.0712 182.694 61.0712C173.003 61.0712 165.147 68.9408 165.147 78.6484C165.147 88.3561 173.003 96.2257 182.694 96.2257Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3366 90.6647C109.424 90.6647 125.707 74.3527 125.707 54.2308C125.707 34.1089 109.424 17.7969 89.3366 17.7969C69.2496 17.7969 52.9658 34.1089 52.9658 54.2308C52.9658 74.3527 69.2496 90.6647 89.3366 90.6647Z",
    fill: "#EFF8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.268 81.0216C196.581 74.0602 192.012 67.3505 185.062 66.0351C178.113 64.7197 171.415 69.2968 170.102 76.2582C168.789 83.2197 173.358 89.9294 180.307 91.2447C187.256 92.5601 193.955 87.9831 195.268 81.0216Z",
    fill: "#D3E6F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.694 81.919C184.497 81.919 185.959 80.4547 185.959 78.6484C185.959 76.8421 184.497 75.3778 182.694 75.3778C180.891 75.3778 179.429 76.8421 179.429 78.6484C179.429 80.4547 180.891 81.919 182.694 81.919Z",
    fill: "#E5F3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3366 61.5114L53.2885 59.0937C53.0757 57.5014 52.9658 55.8815 52.9658 54.2308C52.9658 34.1086 69.2492 17.7969 89.3366 17.7969C109.424 17.7969 125.707 34.1086 125.707 54.2308C125.707 55.8781 125.597 57.5014 125.385 59.0937L89.3366 61.5114Z",
    fill: "#E5F3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3366 85.2377C97.048 85.2377 103.299 78.9756 103.299 71.2509C103.299 63.5262 97.048 57.264 89.3366 57.264C81.6253 57.264 75.374 63.5262 75.374 71.2509C75.374 78.9756 81.6253 85.2377 89.3366 85.2377Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2292 41.4682L108.157 39.9275C111.855 39.9172 115.659 45.461 117.337 48.2398L115.638 50.0866C115.638 50.0866 114.251 48.6216 111.158 48.6594L90.2327 50.3446V41.4682H90.2292Z",
    fill: "#D3E6F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9245 41.4683L70.9966 39.9275C67.6013 39.6524 63.4952 45.4611 61.8164 48.2398L63.5158 50.0867C63.5158 50.0867 64.9028 48.6216 67.9961 48.6594L88.9211 50.3446V41.4683H88.9245Z",
    fill: "#D3E6F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.346 49.5294C110.752 44.8213 107.312 40.1751 107.278 40.1304L108.099 39.5148C108.246 39.7142 111.734 44.4189 112.363 49.4022L111.346 49.5294Z",
    fill: "#E5F3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.087 50.0659C101.483 45.2718 99.5433 39.8827 99.5227 39.8277L100.487 39.4769C100.508 39.532 102.486 45.0311 103.107 49.9353L102.091 50.0625L102.087 50.0659Z",
    fill: "#E5F3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4332 49.5294L66.417 49.4022C67.0453 44.4189 70.5333 39.7142 70.681 39.5148L71.5015 40.1304C71.4671 40.1751 68.0271 44.8213 67.4332 49.5294Z",
    fill: "#E5F3FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6922 50.066L75.676 49.9388C76.294 45.0346 78.2749 39.5355 78.2955 39.4805L79.2602 39.8313C79.2396 39.8863 77.2999 45.2788 76.6957 50.0695L76.6922 50.066Z",
    fill: "#E5F3FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68,
    d: "M105.328 84.8319L215 57.092V84.77L105.328 84.8319Z",
    fill: "url(#paint5_linear_6391_340898)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68,
    d: "M159.634 -3.66663L10 34.1807V-3.58409L159.634 -3.66663Z",
    fill: "url(#paint6_linear_6391_340898)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68,
    d: "M10 41.0452L185.959 -3.66663H215V-2.56955L10 49.3403V41.0452Z",
    fill: "url(#paint7_linear_6391_340898)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M215 85.3787H10V133H215V85.3787Z",
    fill: "url(#paint8_linear_6391_340898)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215 84.4364H10V85.3822H215V84.4364Z",
    fill: "url(#paint9_linear_6391_340898)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.862 -3.66663H199.534V84.4364H204.862V-3.66663Z",
    fill: "url(#paint10_linear_6391_340898)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4869 -3.66663H20.1587V84.4364H25.4869V-3.66663Z",
    fill: "url(#paint11_linear_6391_340898)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.024 -3.66663H141.788V84.4364H143.024V-3.66663Z",
    fill: "url(#paint12_linear_6391_340898)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2325 -3.66663H81.9966V84.4364H83.2325V-3.66663Z",
    fill: "url(#paint13_linear_6391_340898)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215 14.5675H10V15.276H215V14.5675Z",
    fill: "url(#paint14_linear_6391_340898)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M215 62.3951H10V63.1036H215V62.3951Z",
    fill: "url(#paint15_linear_6391_340898)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M215 96.6968V133H13.5979L157.031 96.6934L215 96.6968Z",
    fill: "url(#paint16_linear_6391_340898)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215 85.3306H10V95.7511H215V85.3306Z",
    fill: "url(#paint17_linear_6391_340898)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M215 95.7511H10V96.6969H215V95.7511Z",
    fill: "url(#paint18_linear_6391_340898)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M108.016 96.6934L10 121.579V128.67L136.412 96.6934H108.016Z",
    fill: "url(#paint19_linear_6391_340898)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0893 125.97C10.0584 125.97 10.0309 125.97 10 125.967V124.096L50.0511 113.679C50.5489 113.548 51.057 113.848 51.1875 114.35C51.3179 114.848 51.0192 115.357 50.518 115.488L10.3227 125.939C10.2438 125.96 10.1648 125.97 10.0893 125.97Z",
    fill: "url(#paint20_linear_6391_340898)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4829 133L133.411 113.676C133.909 113.549 134.417 113.848 134.548 114.346C134.678 114.845 134.376 115.354 133.878 115.485L66.2178 133H58.4863H58.4829Z",
    fill: "url(#paint21_linear_6391_340898)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.797 133L178.372 113.676C178.869 113.549 179.378 113.848 179.508 114.346C179.638 114.845 179.336 115.354 178.839 115.485L111.178 133H103.8H103.797Z",
    fill: "url(#paint22_linear_6391_340898)"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6138 133L91.393 114.58H96.1308C96.1308 114.996 95.8493 115.378 95.427 115.485L26.2628 133H18.6138Z",
    fill: "url(#paint23_linear_6391_340898)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5806 113.755L94.651 108.679L127.939 111.523L125 114.58H85.6802C85.1858 114.58 85.1 113.872 85.5806 113.755Z",
    fill: "url(#paint24_linear_6391_340898)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.038 95.7682C102.767 95.7682 102.544 95.5481 102.544 95.273V83.2911H95.6604V95.273C95.6604 95.5447 95.4407 95.7682 95.166 95.7682C94.8914 95.7682 94.6716 95.5481 94.6716 95.273V82.7959C94.6716 82.5242 94.8914 82.3007 95.166 82.3007H103.038C103.309 82.3007 103.533 82.5208 103.533 82.7959V95.273C103.533 95.5447 103.313 95.7682 103.038 95.7682Z",
    fill: "url(#paint25_linear_6391_340898)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.038 85.186C102.609 85.186 102.262 84.8387 102.262 84.4088V83.4046H95.9007V84.4088C95.9007 84.8387 95.5539 85.186 95.1248 85.186C94.6956 85.186 94.3489 84.8387 94.3489 84.4088V82.6273C94.3489 82.1974 94.6956 81.8501 95.1248 81.8501H103.038C103.467 81.8501 103.814 82.1974 103.814 82.6273V84.4088C103.814 84.8387 103.467 85.186 103.038 85.186Z",
    fill: "url(#paint26_linear_6391_340898)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.393 89.0551H88.5057C84.4717 89.0551 81.2 92.3325 81.2 96.3735V111.206C81.2 112.345 82.1235 113.27 83.2598 113.27H114.642C115.779 113.27 116.702 112.345 116.702 111.206V96.3735C116.702 92.3325 113.43 89.0551 109.396 89.0551H109.393Z",
    fill: "url(#paint27_linear_6391_340898)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.947 113.273H83.5276V113.287C83.5276 113.995 84.1009 114.573 84.8116 114.573H85.6664C86.3737 114.573 86.9504 113.999 86.9504 113.287V113.273H86.947Z",
    fill: "url(#paint28_linear_6391_340898)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.206 113.273H110.787V113.287C110.787 113.995 111.36 114.573 112.071 114.573H112.926C113.633 114.573 114.21 113.999 114.21 113.287V113.273H114.206Z",
    fill: "url(#paint29_linear_6391_340898)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.986 112.001H82.9612C82.7449 112.001 82.5732 111.825 82.5732 111.612V103.541C82.5732 99.534 85.8279 96.2737 89.8275 96.2737H108.119C112.119 96.2737 115.374 99.534 115.374 103.541V111.612C115.374 111.829 115.198 112.001 114.986 112.001ZM83.3491 111.223H114.598V103.541C114.598 99.9638 111.693 97.0509 108.119 97.0509H89.8275C86.257 97.0509 83.3491 99.9604 83.3491 103.541V111.223Z",
    fill: "url(#paint30_linear_6391_340898)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M121.073 80.2889C120.801 80.2889 120.578 80.0688 120.578 79.7936V53.4879H110.739V79.7936C110.739 80.0653 110.519 80.2889 110.244 80.2889C109.97 80.2889 109.75 80.0688 109.75 79.7936V52.9927C109.75 52.721 109.97 52.4974 110.244 52.4974H121.073C121.344 52.4974 121.567 52.7175 121.567 52.9927V79.7936C121.567 80.0653 121.347 80.2889 121.073 80.2889Z",
    fill: "url(#paint31_linear_6391_340898)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.072 57.9449C120.643 57.9449 120.297 57.5976 120.297 57.1677V53.6048H110.979V57.1677C110.979 57.5976 110.632 57.9449 110.203 57.9449C109.774 57.9449 109.427 57.5976 109.427 57.1677V52.8275C109.427 52.3976 109.774 52.0503 110.203 52.0503H121.072C121.502 52.0503 121.848 52.3976 121.848 52.8275V57.1677C121.848 57.5976 121.502 57.9449 121.072 57.9449Z",
    fill: "url(#paint32_linear_6391_340898)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.155 80.3267H106.955C103.807 80.3267 101.253 82.8854 101.253 86.039V109.937C101.253 111.86 102.808 113.414 104.724 113.414H126.384C128.303 113.414 129.854 111.856 129.854 109.937V86.039C129.854 82.8854 127.3 80.3267 124.152 80.3267H124.155Z",
    fill: "url(#paint33_linear_6391_340898)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.253 104.717V109.934C101.253 111.856 102.808 113.411 104.724 113.411H126.384C128.303 113.411 129.854 111.853 129.854 109.934V104.717H101.25H101.253Z",
    fill: "url(#paint34_linear_6391_340898)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M108.016 113.414H104.597V113.428C104.597 114.137 105.17 114.714 105.881 114.714H106.736C107.443 114.714 108.02 114.14 108.02 113.428V113.414H108.016Z",
    fill: "url(#paint35_linear_6391_340898)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M126.71 113.414H123.29V113.428C123.29 114.137 123.864 114.714 124.574 114.714H125.429C126.136 114.714 126.713 114.14 126.713 113.428V113.414H126.71Z",
    fill: "url(#paint36_linear_6391_340898)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.485 83.972H106.629C105.382 83.972 104.37 84.9852 104.37 86.235V101.106C104.37 102.355 105.382 103.369 106.629 103.369H124.485C125.733 103.369 126.744 102.355 126.744 101.106V86.235C126.744 84.9852 125.733 83.972 124.485 83.972Z",
    fill: "url(#paint37_linear_6391_340898)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M127.939 91.8202C127.723 91.8202 127.551 91.6448 127.551 91.4315V86.5067C127.551 84.4811 125.906 82.8303 123.881 82.8303H107.227C105.205 82.8303 103.557 84.4777 103.557 86.5067V91.4315C103.557 91.6482 103.382 91.8202 103.169 91.8202C102.956 91.8202 102.781 91.6448 102.781 91.4315V86.5067C102.781 84.0512 104.775 82.0531 107.227 82.0531H123.881C126.332 82.0531 128.327 84.0512 128.327 86.5067V91.4315C128.327 91.6482 128.152 91.8202 127.939 91.8202Z",
    fill: "url(#paint38_linear_6391_340898)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.169 95.0872C102.867 95.0872 102.626 94.8431 102.626 94.5439V90.9706C102.626 90.668 102.87 90.4272 103.169 90.4272C103.467 90.4272 103.711 90.6714 103.711 90.9706V94.5439C103.711 94.8465 103.467 95.0872 103.169 95.0872Z",
    fill: "url(#paint39_linear_6391_340898)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M123.297 86.0012H107.81C106.986 86.0012 106.317 86.671 106.317 87.4972V100.081C106.317 100.907 106.986 101.577 107.81 101.577H123.297C124.122 101.577 124.791 100.907 124.791 100.081V87.4972C124.791 86.671 124.122 86.0012 123.297 86.0012Z",
    fill: "url(#paint40_linear_6391_340898)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M123.51 89.5607H108.586C108.37 89.5607 108.198 89.3853 108.198 89.1721C108.198 88.9588 108.373 88.7834 108.586 88.7834H123.51C123.726 88.7834 123.898 88.9588 123.898 89.1721C123.898 89.3853 123.723 89.5607 123.51 89.5607Z",
    fill: "url(#paint41_linear_6391_340898)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M108.586 93.3023C108.284 93.3023 108.04 93.0581 108.04 92.7589V89.1857C108.04 88.8831 108.284 88.6423 108.586 88.6423C108.888 88.6423 109.129 88.8865 109.129 89.1857V92.7589C109.129 93.0616 108.885 93.3023 108.586 93.3023Z",
    fill: "url(#paint42_linear_6391_340898)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M119.301 105.246L124.471 96.15L120.121 93.6704L113.544 105.246H119.301Z",
    fill: "url(#paint43_linear_6391_340898)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M118.611 105.209L123.393 96.7793L120.266 95.0322L114.567 105.209H118.611Z",
    fill: "url(#paint44_linear_6391_340898)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M115.672 105.394C115.641 105.394 115.61 105.387 115.583 105.37C115.494 105.319 115.463 105.205 115.511 105.116L120.338 96.5007C120.389 96.4113 120.499 96.3803 120.592 96.4285C120.681 96.4801 120.712 96.5936 120.664 96.683L115.837 105.298C115.803 105.36 115.741 105.394 115.676 105.394H115.672Z",
    fill: "url(#paint45_linear_6391_340898)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M119.919 100.091C119.888 100.091 119.857 100.084 119.83 100.067C119.74 100.016 119.709 99.9021 119.758 99.8127L121.611 96.5042C121.663 96.4148 121.773 96.3839 121.865 96.432C121.955 96.4836 121.986 96.5971 121.938 96.6865L120.084 99.9949C120.049 100.057 119.988 100.091 119.922 100.091H119.919Z",
    fill: "url(#paint46_linear_6391_340898)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M123.678 105.246L127.081 99.2589L122.731 96.7793L117.917 105.246H123.678Z",
    fill: "url(#paint47_linear_6391_340898)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M122.957 105.246L126.126 99.737L122.851 97.8627L118.669 105.246H122.957Z",
    fill: "url(#paint48_linear_6391_340898)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.471 102.395C121.44 102.395 121.409 102.389 121.382 102.371C121.292 102.32 121.261 102.206 121.309 102.117L123.163 98.8084C123.215 98.719 123.325 98.6881 123.417 98.7362C123.507 98.7878 123.538 98.9013 123.489 98.9907L121.636 102.299C121.601 102.361 121.539 102.395 121.474 102.395H121.471Z",
    fill: "url(#paint49_linear_6391_340898)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M122.398 102.853C122.367 102.853 122.336 102.846 122.308 102.829C122.219 102.777 122.188 102.664 122.236 102.574L124.09 99.2658C124.142 99.1764 124.252 99.1455 124.344 99.1936C124.434 99.2452 124.464 99.3587 124.416 99.4481L122.562 102.757C122.528 102.818 122.466 102.853 122.401 102.853H122.398Z",
    fill: "url(#paint50_linear_6391_340898)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M123.393 103.393C123.362 103.393 123.331 103.386 123.304 103.369C123.215 103.317 123.184 103.204 123.232 103.114L125.086 99.8058C125.137 99.7163 125.247 99.6854 125.34 99.7335C125.429 99.7851 125.46 99.8986 125.412 99.988L123.558 103.296C123.524 103.358 123.462 103.393 123.397 103.393H123.393Z",
    fill: "url(#paint51_linear_6391_340898)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M129.858 104.717H101.253V105.494H129.858V104.717Z",
    fill: "url(#paint52_linear_6391_340898)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.169 109.225C102.867 109.225 102.626 108.981 102.626 108.682V105.109C102.626 104.806 102.87 104.565 103.169 104.565C103.467 104.565 103.711 104.81 103.711 105.109V108.682C103.711 108.985 103.467 109.225 103.169 109.225Z",
    fill: "url(#paint53_linear_6391_340898)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M104.913 109.225C104.61 109.225 104.37 108.981 104.37 108.682V105.109C104.37 104.806 104.614 104.565 104.913 104.565C105.211 104.565 105.455 104.81 105.455 105.109V108.682C105.455 108.985 105.211 109.225 104.913 109.225Z",
    fill: "url(#paint54_linear_6391_340898)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M122.013 78.9097H109.087C108.325 78.9097 107.707 79.5287 107.707 80.2922V80.3059H123.393V80.2922C123.393 79.5287 122.775 78.9097 122.013 78.9097Z",
    fill: "url(#paint55_linear_6391_340898)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4444 61.3566C66.2488 62.715 65.5724 63.31 65.2085 63.8499C64.8446 64.3899 64.539 66.3261 63.3271 66.67L63.8764 68.4411C63.8764 68.4411 67.7559 67.9768 68.1816 67.0896C68.3052 66.8282 68.2537 66.4361 68.3498 66.0303C68.3876 65.8721 68.6485 65.7621 68.6451 65.542C68.6451 65.2565 68.4254 65.1877 68.4357 64.9608C68.4528 64.5618 68.8751 64.4414 68.7721 64.0184C68.6726 63.6126 66.4925 63.8637 66.4925 63.8637C66.4925 63.8637 67.1929 62.3401 67.0727 61.814C66.9937 61.4769 66.4513 61.36 66.4513 61.36L66.4444 61.3566Z",
    fill: "url(#paint56_linear_6391_340898)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0495 114.838C48.0495 114.838 48.0392 114.838 48.0358 114.838C47.895 114.831 47.7852 114.707 47.7921 114.566C47.7955 114.501 48.1937 108.087 51.8981 101.642C54.0747 97.849 56.9551 94.7847 60.4501 92.5356C64.817 89.7224 70.1624 88.1816 76.3421 87.9512C76.4863 87.9443 76.603 88.0578 76.6099 88.1988C76.6167 88.3398 76.5035 88.4602 76.3627 88.4671C62.6061 88.9795 55.7158 96.0469 52.3581 101.886C48.7087 108.228 48.3139 114.539 48.3105 114.601C48.3036 114.738 48.1903 114.845 48.053 114.845L48.0495 114.838Z",
    fill: "url(#paint57_linear_6391_340898)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5878 48.3842C38.0316 49.0067 33.9771 49.5054 33.9771 53.8902C33.9771 58.815 38.8075 58.7669 39.2607 59.5407C35.9717 59.41 35.0654 68.6612 43.8679 66.02C43.8679 66.02 46.2162 58.5158 47.7268 54.5815C48.6949 52.0606 39.1474 47.7618 38.5912 48.3877L38.5878 48.3842Z",
    fill: "url(#paint58_linear_6391_340898)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6882 93.2233C91.5063 93.2233 91.3209 93.1923 91.1389 93.1236L83.4624 90.3001C83.4246 90.2863 83.3903 90.2725 83.356 90.2553C82.4565 89.8495 81.1244 89.6707 79.8782 89.7945L69.8877 90.7678C62.146 91.772 56.804 89.6948 53.0756 84.2335L38.5706 62.9763C38.0728 62.2473 38.2582 61.2499 38.9894 60.7512C39.7173 60.2526 40.7129 60.4383 41.2107 61.1708L55.7157 82.4279C58.73 86.8472 62.9837 88.4395 69.4998 87.59C69.517 87.59 69.5341 87.5866 69.5513 87.5831L79.5692 86.6064C81.3407 86.4345 83.2255 86.6959 84.6194 87.3115L92.2444 90.1143C93.0752 90.4204 93.4975 91.3387 93.1954 92.1709C92.9585 92.8209 92.3439 93.2199 91.6951 93.2233H91.6882Z",
    fill: "url(#paint59_linear_6391_340898)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2845 115.316C50.2639 115.316 50.2399 115.316 50.2193 115.316C49.8142 115.282 49.5189 114.924 49.5533 114.518C49.5773 114.25 50.185 107.833 54.497 101.216C57.0375 97.3228 60.3368 94.1794 64.3055 91.8752C69.2492 89.007 75.24 87.4456 82.1132 87.2324C82.5149 87.2255 82.8548 87.5385 82.8685 87.9443C82.8822 88.3501 82.5629 88.6871 82.1578 88.7009C70.1384 89.0723 61.2465 93.5535 55.726 102.017C51.6097 108.331 51.0192 114.584 51.0158 114.646C50.9814 115.027 50.6622 115.316 50.2845 115.316Z",
    fill: "url(#paint60_linear_6391_340898)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5955 87.4869C71.5118 86.8541 88.0287 75.5807 88.0287 75.5807L119.003 78.8169L119.253 76.1894C119.253 76.1894 89.7349 68.2795 86.1542 68.2898C83.4523 68.2967 64.7073 74.7347 64.7073 74.7347C64.7073 74.7347 61.6758 88.1197 66.5955 87.4869Z",
    fill: "url(#paint61_linear_6391_340898)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3897 35.2779C58.9087 34.6485 58.737 41.8672 57.6247 43.6693C61.614 47.6656 58.5963 53.3951 56.9174 55.7991C60.4158 56.7689 60.9651 61.7384 60.9651 61.7384C60.9651 61.7384 58.8331 60.6482 55.6506 60.7617C52.4681 60.8752 41.7395 55.4586 41.7395 55.4586L49.2169 34.8102C49.2169 34.8102 51.8707 35.9038 55.3931 35.2745L55.3897 35.2779Z",
    fill: "url(#paint62_linear_6391_340898)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5521 54.8223C54.5521 54.8223 53.1823 53.5395 51.8124 54.2927C44.8775 58.1169 55.3314 74.8654 57.0205 74.9067C58.7096 74.9479 65.2704 66.1369 65.2704 66.1369L64.7897 65.4491L57.8651 68.8022C57.8651 68.8022 56.7905 56.0569 54.5521 54.8223Z",
    fill: "url(#paint63_linear_6391_340898)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M54.552 54.8223C54.552 54.8223 53.1822 53.5395 51.8123 54.2927C48.3655 56.191 50.6416 61.2156 54.013 65.7896L59.6296 62.8182C57.8547 59.2966 55.7193 55.4654 54.552 54.8188V54.8223Z",
    fill: "#EEA601"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8608 78.2495C54.8608 78.2495 56.7697 81.582 57.2778 82.7857C57.7859 83.9894 59.9453 89.0449 67.1515 87.37C74.3577 85.6952 74.8829 67.3888 74.8829 67.3888C74.8829 67.3888 80.963 75.536 84.6811 82.5828H87.2114C87.2114 82.5828 81.6325 54.7638 76.2974 54.757C69.6371 54.7501 61.504 75.9143 61.504 75.9143L54.8608 78.2529V78.2495Z",
    fill: "url(#paint64_linear_6391_340898)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4063 59.1555C51.6167 57.7077 49.1723 54.2307 51.1944 50.9051C53.2165 47.5795 47.5415 45.688 47.5415 45.688C47.5415 45.688 47.8368 52.5387 45.976 53.9453C44.1152 55.3519 52.4063 59.1555 52.4063 59.1555Z",
    fill: "url(#paint65_linear_6391_340898)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M54.861 78.2495C53.2027 75.1646 49.4812 72.9533 47.7852 70.7385C45.6533 67.9562 43.2775 63.4923 43.947 58.7497C44.7675 52.9377 46.5356 52.0572 50.494 53.7974C54.4524 55.5376 52.9762 55.5135 55.4618 58.2064C57.5525 60.4659 59.7669 60.6103 61.4389 62.1304C62.2182 66.5943 60.457 67.9906 60.457 67.9906C60.457 67.9906 62.2594 71.557 62.7744 73.8337C63.2893 76.1104 61.1024 77.909 61.1024 77.909L54.8575 78.2495H54.861Z",
    fill: "#D66855"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M54.861 78.2495C53.2027 75.1646 49.4812 72.9533 47.7852 70.7385C45.6533 67.9562 43.2775 63.4923 43.947 58.7497C44.7675 52.9377 46.5356 52.0572 50.494 53.7974C54.4524 55.5376 52.9762 55.5135 55.4618 58.2064C57.5525 60.4659 59.7669 60.6103 61.4389 62.1304C62.2182 66.5943 60.457 67.9906 60.457 67.9906C60.457 67.9906 62.2594 71.557 62.7744 73.8337C63.2893 76.1104 61.1024 77.909 61.1024 77.909L54.8575 78.2495H54.861Z",
    fill: "url(#paint66_linear_6391_340898)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3938 48.9139C47.3938 48.9139 48.8769 51.4486 50.4768 52.8208C50.5798 52.1467 50.9162 51.3591 51.1909 50.9052C51.7505 49.9835 51.7196 49.1753 51.3831 48.484L47.5552 46.6304C47.5552 47.1084 47.4281 48.2296 47.3904 48.9139H47.3938Z",
    fill: "url(#paint67_linear_6391_340898)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6422 59.104C53.5118 59.104 53.3985 59.0042 53.3848 58.8667C53.244 57.2262 53.4019 55.3244 53.5564 53.4845C53.7796 50.802 53.9924 48.2673 53.2612 46.9089C53.1925 46.7851 53.2406 46.6269 53.3642 46.5581C53.4878 46.4893 53.6457 46.5375 53.7143 46.6613C54.5177 48.1538 54.3014 50.7641 54.0714 53.5257C53.9203 55.3416 53.7624 57.2228 53.8997 58.8185C53.9135 58.9595 53.807 59.0868 53.6663 59.0971C53.6594 59.0971 53.6525 59.0971 53.6422 59.0971V59.104Z",
    fill: "#E0DEEC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4569 37.2828C54.504 37.5889 56.0317 39.1777 56.2206 40.911C56.5845 44.2745 56.8488 47.1977 55.273 51.1011C55.1426 51.421 54.8645 51.6514 54.5246 51.7098C53.3642 51.9128 50.5765 51.9643 48.2969 48.539C45.3306 44.0922 47.5004 35.5426 53.4569 37.2828Z",
    fill: "url(#paint68_linear_6391_340898)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4265 44.9933C56.8831 46.2073 57.8307 46.2658 57.865 46.5684C57.8994 46.871 57.2162 47.6173 56.3304 47.8443C55.4447 48.0713 56.4265 44.9933 56.4265 44.9933Z",
    fill: "url(#paint69_linear_6391_340898)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6365 82.2079C84.6365 82.2079 83.5447 83.1502 83.4314 83.7486C83.3181 84.347 92.8623 88.7181 92.8623 88.7181L87.3555 82.5793L84.6365 82.2079Z",
    fill: "url(#paint70_linear_6391_340898)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9504 84.3849C86.6139 84.4158 85.862 84.2783 85.3574 83.9447C84.142 83.1468 83.9395 82.5793 83.785 82.5793C83.6305 82.5793 82.398 83.8656 82.4117 84.9523C82.4255 86.0425 86.5075 86.5102 86.5075 86.5102L86.9504 84.3814V84.3849Z",
    fill: "url(#paint71_linear_6391_340898)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6776 89.21C95.7188 89.0656 95.5025 88.6081 94.7507 88.2711C90.6755 86.4381 88.904 82.8098 88.904 82.8098C88.904 82.8098 86.6073 83.6146 87.1875 86.7648L91.115 88.192L95.6742 89.21H95.6776Z",
    fill: "url(#paint72_linear_6391_340898)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3424 87.7965C90.6343 87.7071 92.4298 86.9849 91.9698 86.3487C90.7716 85.1828 89.8515 83.5355 88.9726 83.6868C88.0937 83.8381 86.3566 84.7495 85.4536 84.4606C84.5507 84.1683 83.435 82.8683 83.435 82.8683L82.9062 83.5492C82.9062 83.5492 85.6322 85.9669 85.9617 86.3143C86.2879 86.6651 90.3424 87.8 90.3424 87.8V87.7965Z",
    fill: "url(#paint73_linear_6391_340898)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6775 89.21C96.0209 89.4507 95.602 90.5822 95.602 90.5822C95.602 90.5822 92.2856 90.2383 89.6764 89.2478C85.1824 87.542 81.9312 86.5172 81.9793 86.2455C82.0273 85.9772 82.4084 84.9558 82.4084 84.9558C82.4084 84.9558 86.9608 86.7338 88.6602 87.2806C92.1208 88.3949 95.6741 89.21 95.6741 89.21H95.6775Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M95.602 90.5788C95.602 90.5788 93.4528 90.3552 91.2556 89.7499L91.5715 88.5875C91.5715 88.5875 94.215 89.2685 95.8114 89.5436C95.832 89.9632 95.6054 90.5788 95.6054 90.5788H95.602Z",
    fill: "#ECEBF1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5229 83.8002C88.6877 83.7486 88.8388 83.7108 88.9727 83.6867C89.8516 83.5354 90.7717 85.1862 91.9698 86.3486C92.138 86.5824 92.0248 86.8782 91.5853 87.1808C91.1459 86.8679 89.4808 85.2584 88.5264 83.8002H88.5229Z",
    fill: "url(#paint74_linear_6391_340898)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3606 84.488C89.2817 84.488 89.2027 84.4502 89.1512 84.3814C89.0688 84.2645 89.0963 84.1063 89.2096 84.0203L89.601 83.7418C89.7177 83.6592 89.8756 83.6867 89.9614 83.8002C90.0438 83.9171 90.0164 84.0753 89.9031 84.1613L89.5117 84.4399C89.4671 84.4708 89.4156 84.488 89.3606 84.488Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0093 85.2034C89.9303 85.2034 89.8548 85.169 89.8033 85.1002C89.7175 84.9867 89.7415 84.8251 89.8548 84.7391L90.2839 84.4158C90.3972 84.3298 90.5586 84.3539 90.6444 84.4674C90.7302 84.5809 90.7062 84.7425 90.5929 84.8285L90.1638 85.1518C90.1191 85.1862 90.0642 85.2034 90.0093 85.2034Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6685 85.9359C90.5895 85.9359 90.514 85.9015 90.4625 85.8327C90.3767 85.7192 90.3973 85.5576 90.5106 85.4716L90.9191 85.1621C91.0324 85.0761 91.1938 85.0967 91.2796 85.2102C91.3654 85.3237 91.3448 85.4854 91.2315 85.5713L90.823 85.8808C90.7749 85.9152 90.72 85.9324 90.6685 85.9324V85.9359Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3277 86.6857C91.2556 86.6857 91.1869 86.6582 91.1354 86.5997C91.0393 86.4931 91.0496 86.3315 91.156 86.2352L91.5405 85.8947C91.647 85.7984 91.8083 85.8087 91.9045 85.9153C92.0006 86.022 91.9903 86.1836 91.8839 86.2799L91.4993 86.6204C91.4513 86.6651 91.3895 86.6857 91.3277 86.6857Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M119.02 78.8789C119.02 78.8789 120.228 79.6665 120.832 79.6046C121.437 79.5461 122.957 69.1462 122.957 69.1462L118.615 76.1586L119.02 78.8755V78.8789Z",
    fill: "url(#paint75_linear_6391_340898)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M120.458 76.0485C120.582 76.3649 120.661 77.125 120.482 77.7027C120.056 79.0921 119.572 79.4498 119.614 79.5977C119.655 79.7456 121.234 80.5709 122.271 80.2545C123.311 79.9347 122.621 75.88 122.621 75.88L120.458 76.0485Z",
    fill: "url(#paint76_linear_6391_340898)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M122.642 66.3055C122.49 66.3055 122.116 66.6426 122 67.4611C121.385 71.8941 118.402 74.611 118.402 74.611C118.402 74.611 119.816 76.5953 122.672 75.1544L122.94 70.9758L122.642 66.3055Z",
    fill: "url(#paint77_linear_6391_340898)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M122.779 71.8287C122.611 71.5742 121.416 70.0472 120.935 70.6697C120.152 72.1485 118.831 73.4966 119.222 74.2979C119.613 75.0993 120.973 76.5162 120.946 77.4654C120.918 78.4146 119.984 79.8521 119.984 79.8521L120.784 80.1719C120.784 80.1719 122.336 76.8738 122.58 76.4612C122.823 76.0485 122.779 71.8321 122.779 71.8321V71.8287Z",
    fill: "url(#paint78_linear_6391_340898)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M122.642 66.3055C122.779 65.9066 123.977 65.9925 123.977 65.9925C123.977 65.9925 124.574 69.2803 124.355 72.0626C123.977 76.8636 123.901 80.2752 123.63 80.3061C123.359 80.3336 122.274 80.2545 122.274 80.2545C122.274 80.2545 122.703 75.3779 122.755 73.5895C122.854 69.9475 122.642 66.3055 122.642 66.3055Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M123.977 65.9925C123.977 65.9925 124.365 68.1213 124.399 70.4049L123.194 70.4255C123.194 70.4255 123.105 67.6915 122.923 66.082C123.321 65.9444 123.974 65.9925 123.974 65.9925H123.977Z",
    fill: "#ECEBF1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M119.459 74.6969C119.363 74.5525 119.284 74.4184 119.226 74.298C118.834 73.4967 120.159 72.1486 120.939 70.6697C121.114 70.4428 121.43 70.4703 121.842 70.8073C121.666 71.3197 120.588 73.3694 119.459 74.6969Z",
    fill: "url(#paint79_linear_6391_340898)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M119.638 74.0331C119.583 74.0331 119.524 74.0159 119.48 73.9781L119.102 73.6824C118.989 73.5929 118.971 73.4313 119.057 73.3212C119.147 73.2078 119.308 73.1906 119.418 73.2765L119.795 73.5723C119.909 73.6617 119.926 73.8234 119.84 73.9334C119.789 73.9987 119.713 74.0331 119.638 74.0331Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M120.139 73.2078C120.084 73.2078 120.032 73.1906 119.984 73.1562L119.555 72.8329C119.442 72.7469 119.418 72.5853 119.504 72.4718C119.589 72.3583 119.751 72.3342 119.864 72.4202L120.293 72.7435C120.407 72.8295 120.431 72.9911 120.345 73.1046C120.293 73.1734 120.218 73.2078 120.139 73.2078Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M120.661 72.3687C120.606 72.3687 120.554 72.3515 120.506 72.3171L120.094 72.011C119.981 71.925 119.957 71.7634 120.039 71.6499C120.125 71.5364 120.286 71.5123 120.4 71.5949L120.812 71.901C120.925 71.9869 120.949 72.1486 120.867 72.2621C120.815 72.3308 120.74 72.3652 120.661 72.3652V72.3687Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M121.193 71.5227C121.145 71.5227 121.1 71.5089 121.055 71.4848L120.619 71.2131C120.499 71.1375 120.462 70.9793 120.537 70.8589C120.613 70.7385 120.77 70.7007 120.891 70.7764L121.327 71.0481C121.447 71.1237 121.485 71.2819 121.409 71.4023C121.361 71.4814 121.275 71.5227 121.189 71.5227H121.193Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4729 55.8884C47.4729 55.8884 50.6451 64.0185 50.8065 71.1649L48.2179 72.0144L47.4729 55.8884Z",
    fill: "#EEA601"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1157 55.2281C47.1157 55.2281 46.3158 53.5292 44.764 53.7252C36.9089 54.7122 45.9347 76.0209 47.4899 76.6847C49.0451 77.3484 63.9724 69.7962 63.9724 69.7962L63.7802 68.5512L49.3507 71.4125C49.3507 71.4125 48.7396 57.209 47.1122 55.2315L47.1157 55.2281Z",
    fill: "url(#paint80_linear_6391_340898)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5955 87.4869C71.5118 86.8541 88.0287 75.5807 88.0287 75.5807L114.787 78.3767L115.226 75.1233C107.021 72.9636 88.911 68.2829 86.1542 68.2898C83.4523 68.2967 64.7073 74.7347 64.7073 74.7347C64.7073 74.7347 61.6758 88.1197 66.5955 87.4869Z",
    fill: "url(#paint81_linear_6391_340898)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7578 53.0099L47.0986 53.1199C47.0986 53.1199 49.3851 56.5453 52.4063 57.2056C53.7795 57.5048 51.9565 54.5884 51.9565 54.5884L50.9438 54.0038C50.7996 53.9384 50.6519 53.8731 50.4906 53.8009C49.4297 53.3332 48.5268 53.058 47.7544 53.0133L47.7578 53.0099Z",
    fill: "url(#paint82_linear_6391_340898)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8608 78.2495C54.8608 78.2495 56.7697 81.582 57.2778 82.7857C57.7859 83.9894 59.9453 89.0449 67.1515 87.37C74.3577 85.6952 74.8829 67.3888 74.8829 67.3888C74.8829 67.3888 79.4181 73.4657 83.0504 79.6596L86.2398 78.1532C84.4099 70.3017 80.2867 54.7604 76.3008 54.7535C69.6405 54.7467 61.5074 75.9109 61.5074 75.9109L54.8643 78.2495H54.8608Z",
    fill: "url(#paint83_linear_6391_340898)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1456 67.9941C40.1706 67.9941 39.2265 67.7327 38.3648 67.21C36.5761 66.1266 35.5221 64.0976 35.7384 62.1682C35.8654 61.0368 36.5555 58.9802 39.7483 57.9175C39.8822 57.8728 40.0298 57.945 40.0745 58.0826C40.1191 58.2167 40.047 58.3646 39.9097 58.4093C37.7468 59.1281 36.4456 60.4831 36.2499 62.2267C36.0543 63.9635 37.0121 65.7896 38.6326 66.7698C40.4109 67.8496 42.591 67.6846 44.6131 66.3158C44.7298 66.2367 44.8912 66.2677 44.9701 66.3846C45.0491 66.5015 45.0182 66.6631 44.9015 66.7422C43.6724 67.5745 42.385 67.9906 41.149 67.9906L41.1456 67.9941Z",
    fill: "url(#paint84_linear_6391_340898)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5548 50.4925L44.5376 49.9766C48.781 49.8288 51.5549 48.6938 52.7806 46.5994C54.4766 43.7106 52.7703 39.7075 51.9566 38.1186L51.9292 38.0636L52.3892 37.8297L52.4167 37.8847C53.4741 39.9516 54.9847 43.8619 53.2269 46.8608C51.9051 49.1169 48.987 50.3377 44.5582 50.4925H44.5548Z",
    fill: "url(#paint85_linear_6391_340898)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9938 47.8684L48.8049 47.3904C50.2675 46.8092 51.3111 45.7981 51.9085 44.3881C52.7496 42.4037 52.4578 40.1924 52.0767 39.2604L52.5539 39.0643C52.9831 40.1098 53.2921 42.445 52.3823 44.5875C51.73 46.1283 50.5902 47.2322 48.9938 47.8684Z",
    fill: "url(#paint86_linear_6391_340898)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8903 39.563C53.7623 38.741 55.8291 39.6042 55.8291 39.6042C56.653 31.8766 50.5832 31.7768 48.8975 33.1387C47.6753 34.1257 48.0736 35.2916 47.4728 35.6905C46.872 36.0929 45.1794 34.4181 43.4423 35.7043C41.5369 37.1109 43.02 39.1743 42.6629 39.6317C42.3059 40.0857 38.3303 39.0127 36.9674 41.3066C34.8697 44.8454 39.1371 47.7652 38.5809 48.3877C38.0248 49.0102 46.666 58.846 49.9961 50.379C50.9849 47.8615 48.2487 45.2478 48.513 44.8248C48.7774 44.4018 51.5342 44.3364 52.2105 42.7992C52.8868 41.2619 52.4508 39.9757 52.8868 39.5664L52.8903 39.563Z",
    fill: "url(#paint87_linear_6391_340898)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0726 46.2314C49.155 45.2994 48.4649 44.4774 47.5346 44.3949C46.6042 44.3123 45.7837 45.0036 45.7013 45.9356C45.6189 46.8676 46.3089 47.6895 47.2393 47.7721C48.1697 47.8546 48.9902 47.1633 49.0726 46.2314Z",
    fill: "#D66855"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M48.386 46.1695C48.434 45.6158 48.0255 45.1309 47.4728 45.0793C46.92 45.0311 46.436 45.4404 46.3845 45.9941C46.3364 46.5478 46.7449 47.0327 47.2977 47.0843C47.8504 47.1359 48.3345 46.7232 48.386 46.1695Z",
    fill: "#C04F40"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9406 46.0422C46.7552 46.3724 46.872 46.792 47.2016 46.9811C47.2977 47.0361 47.4007 47.0602 47.5037 47.0671L48.2281 48.3086C48.3242 48.4737 48.537 48.5287 48.7018 48.4324H48.7087C48.8735 48.3327 48.9284 48.1195 48.8323 47.9509L48.1216 46.7369C48.1216 46.7369 48.1319 46.7266 48.1354 46.7197C48.3208 46.3896 48.204 45.97 47.8744 45.7809C47.5449 45.5952 47.126 45.7121 46.9372 46.0422H46.9406Z",
    fill: "#ECEBF1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8428 59.4135C37.8428 59.4135 37.8154 59.4135 37.7982 59.41C34.4921 58.8495 32.7584 56.7757 33.1566 53.8628C33.548 51.0117 36.0782 48.0575 39.0891 48.3739C39.2298 48.3877 39.3328 48.5149 39.3191 48.6559C39.3054 48.7969 39.1783 48.9001 39.0376 48.8864C36.3941 48.6078 34.0252 51.3213 33.6681 53.9315C33.3111 56.5349 34.8869 58.3921 37.884 58.901C38.0248 58.9251 38.1175 59.0592 38.0935 59.1968C38.0729 59.3241 37.963 59.41 37.8394 59.41L37.8428 59.4135Z",
    fill: "url(#paint88_linear_6391_340898)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9915 82.2595C61.9675 82.2595 61.9435 82.2595 61.9229 82.2492C61.7958 82.2148 61.7169 82.0876 61.7375 81.9603C62.2628 78.731 59.8492 77.9056 59.7463 77.8747C59.6124 77.8299 59.5368 77.6855 59.5815 77.5514C59.6261 77.4173 59.7703 77.3416 59.9042 77.3863C59.9282 77.3932 62.043 78.1154 62.3005 80.595C63.1931 78.4765 65.0882 74.1123 67.2545 69.8134C71.3331 61.7315 74.4195 57.7249 76.4313 57.9072C77.4201 57.9966 78.9581 60.5003 81.0077 65.3529C82.7586 69.5004 84.5027 74.5456 85.5635 78.5212C85.6013 78.6588 85.5189 78.7998 85.3816 78.8376C85.2442 78.8754 85.1035 78.7929 85.0657 78.6553C82.6831 69.7136 77.8973 58.5572 76.3867 58.4196C76.3524 58.4196 76.3181 58.4162 76.2872 58.4162C72.6446 58.4162 64.9234 75.4673 62.2319 82.1013C62.1907 82.201 62.0945 82.263 61.995 82.263L61.9915 82.2595Z",
    fill: "url(#paint89_linear_6391_340898)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0596 115.316C94.7197 115.316 94.4142 115.075 94.3421 114.728C91.3758 100.136 85.0657 89.6638 75.5799 83.6041C68.415 79.0232 60.7316 77.878 55.5441 77.7232C49.8966 77.5513 45.9038 78.4902 45.8626 78.5005C45.4678 78.5933 45.073 78.3526 44.9803 77.9571C44.8876 77.5616 45.1279 77.1661 45.5227 77.0732C45.691 77.032 49.7112 76.0897 55.5338 76.2547C60.9135 76.4095 68.8922 77.5925 76.3524 82.3592C86.1918 88.6424 92.7285 99.4378 95.7771 114.439C95.8595 114.838 95.602 115.223 95.2038 115.306C95.1557 115.316 95.1042 115.32 95.0562 115.32L95.0596 115.316Z",
    fill: "url(#paint90_linear_6391_340898)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1159 55.2281C47.1159 55.2281 46.3159 53.5292 44.7642 53.7252C40.1466 54.3064 41.3653 61.9103 43.4664 68.2142L49.0934 67.0861C48.7775 62.7357 48.1527 56.4903 47.1159 55.2281Z",
    fill: "url(#paint91_linear_6391_340898)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M52.42 91.0739C51.6853 91.0739 50.9506 90.9948 50.2297 90.8297C45.2104 89.6914 42.4776 84.77 42.7386 80.6672C42.9651 77.0802 45.2688 74.7313 48.9045 74.3805C49.7284 74.3014 50.446 74.3805 51.0502 74.5765C58.6031 66.6666 52.0149 54.8704 49.1345 49.7152C48.6264 48.8073 48.2281 48.0885 48.0325 47.6242C47.9775 47.4935 48.0393 47.3422 48.1698 47.2872C48.3002 47.2322 48.4513 47.2941 48.5062 47.4248C48.6882 47.8615 49.083 48.5665 49.5808 49.4607C52.5024 54.6881 59.1593 66.6115 51.5652 74.7794C52.5711 75.2609 53.1925 76.0828 53.4088 76.9426C53.7383 78.2495 53.1341 79.4772 51.9085 79.9931C50.9335 80.4023 49.7937 80.0034 49.1997 79.0439C48.6573 78.1669 48.5921 76.7878 50.0306 75.5429C50.2365 75.3641 50.4391 75.1818 50.6279 74.9961C50.1404 74.8757 49.5808 74.831 48.9491 74.8929C45.5881 75.2162 43.4561 77.3862 43.2467 80.6981C42.9995 84.5843 45.5881 89.2477 50.3395 90.3242C53.3847 91.0154 56.7115 90.1316 59.2382 87.9649C62.2663 85.3684 65.7029 79.7558 64.8926 67.7464C64.8823 67.6054 64.9888 67.4816 65.133 67.4713C65.2703 67.461 65.3973 67.5676 65.4076 67.712C66.2316 79.9312 62.692 85.6848 59.5747 88.357C57.5217 90.1178 54.9571 91.0705 52.4166 91.0705L52.42 91.0739ZM51.1841 75.1783C50.9266 75.4328 50.6554 75.6873 50.3704 75.9349C49.1757 76.9667 49.21 78.0775 49.6392 78.7722C50.034 79.4084 50.8717 79.8727 51.7094 79.5185C52.8457 79.0405 53.1307 77.9434 52.911 77.0698C52.7187 76.3064 52.1385 75.5773 51.1841 75.1783Z",
    fill: "#ECEBF1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0832 71.2406C62.9837 71.2406 62.8841 71.2165 62.7948 71.1649C62.503 71.0033 62.4 70.6388 62.558 70.3464L68.8921 58.8633C69.0535 58.5709 69.4174 58.4678 69.7092 58.626C70.001 58.7876 70.104 59.1521 69.9461 59.4445L63.6119 70.9276C63.5021 71.1271 63.2961 71.2372 63.0867 71.2372L63.0832 71.2406Z",
    fill: "#1A305D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9142 63.8087C63.7185 65.1672 63.0422 65.7621 62.6782 66.3021C62.3143 66.842 62.0088 68.7782 60.7969 69.1221L61.3462 70.8933C61.3462 70.8933 65.2256 70.429 65.6513 69.5417C65.7749 69.2803 65.7234 68.8883 65.8196 68.4825C65.8573 68.3243 66.1182 68.2142 66.1148 67.9941C66.1148 67.7087 65.8951 67.6399 65.9054 67.4129C65.9226 67.014 66.3448 66.8936 66.2418 66.4706C66.1423 66.0648 63.9622 66.3158 63.9622 66.3158C63.9622 66.3158 64.6626 64.7923 64.5424 64.2661C64.4635 63.9291 63.921 63.8122 63.921 63.8122L63.9142 63.8087Z",
    fill: "url(#paint92_linear_6391_340898)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M142.591 89.8427C142.564 89.8427 142.533 89.8393 142.502 89.8255C142.368 89.7774 142.3 89.6295 142.348 89.4954C143.079 87.4835 147.298 82.796 154.031 79.1264C159.75 76.0106 168.893 72.7469 179.978 74.8929C180.119 74.9204 180.208 75.0545 180.181 75.1955C180.154 75.3365 180.02 75.4294 179.879 75.3984C168.944 73.28 159.922 76.5024 154.274 79.577C147.655 83.1812 143.532 87.7311 142.828 89.6673C142.791 89.7705 142.691 89.8358 142.588 89.8358L142.591 89.8427Z",
    fill: "url(#paint93_linear_6391_340898)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M137.05 93.2234C136.398 93.2234 135.787 92.821 135.55 92.171C135.245 91.3387 135.67 90.4205 136.501 90.1144L144.126 87.3115C145.52 86.6959 147.401 86.4311 149.176 86.6065L159.194 87.5832C159.194 87.5832 159.229 87.5867 159.246 87.5901C165.762 88.4396 170.015 86.8472 173.03 82.428L187.535 61.1709C188.033 60.4418 189.028 60.2526 189.756 60.7513C190.484 61.25 190.673 62.2473 190.175 62.9764L175.67 84.2335C171.945 89.6948 166.599 91.772 158.858 90.7678L148.867 89.7946C147.621 89.6742 146.286 89.8496 145.39 90.2554C145.355 90.2726 145.317 90.2864 145.283 90.3001L137.607 93.1236C137.425 93.189 137.239 93.2234 137.057 93.2234H137.05Z",
    fill: "url(#paint94_linear_6391_340898)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M178.454 115.316C178.077 115.316 177.757 115.027 177.723 114.646C177.713 114.553 177.101 108.263 172.978 101.966C167.454 93.5329 158.573 89.0689 146.581 88.7009C146.176 88.6871 145.856 88.3501 145.87 87.9443C145.884 87.5385 146.217 87.2255 146.625 87.2324C153.499 87.4456 159.489 89.007 164.433 91.8752C168.402 94.1794 171.701 97.3228 174.242 101.216C178.557 107.833 179.161 114.25 179.185 114.518C179.22 114.924 178.921 115.278 178.519 115.316C178.499 115.316 178.475 115.316 178.454 115.316Z",
    fill: "url(#paint95_linear_6391_340898)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M133.679 115.316C133.631 115.316 133.583 115.313 133.531 115.302C133.133 115.22 132.879 114.835 132.958 114.436C136.007 99.4309 142.543 88.639 152.383 82.3557C159.843 77.5926 167.822 76.4061 173.201 76.2513C179.027 76.0862 183.044 77.0286 183.212 77.0698C183.607 77.1627 183.848 77.5616 183.755 77.9537C183.662 78.3492 183.264 78.5934 182.873 78.4971C182.831 78.4867 178.839 77.5513 173.191 77.7198C168.007 77.8746 160.32 79.0198 153.155 83.6007C143.673 89.6638 137.359 100.136 134.393 114.725C134.321 115.072 134.016 115.313 133.676 115.313L133.679 115.316Z",
    fill: "url(#paint96_linear_6391_340898)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M152.307 13.2263H151.497V20.4656H152.307V13.2263Z",
    fill: "url(#paint97_linear_6391_340898)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M193.072 13.2263H192.262V20.4656H193.072V13.2263Z",
    fill: "url(#paint98_linear_6391_340898)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M152.307 26.2673H151.497V33.5067H152.307V26.2673Z",
    fill: "url(#paint99_linear_6391_340898)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M193.072 26.2673H192.262V33.5067H193.072V26.2673Z",
    fill: "url(#paint100_linear_6391_340898)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M197.051 3.57275H147.219V13.2229H197.051V3.57275Z",
    fill: "url(#paint101_linear_6391_340898)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M162.116 5.71533H158.425C157.964 5.71533 157.591 6.08949 157.591 6.55103V10.2481C157.591 10.7096 157.964 11.0838 158.425 11.0838H162.116C162.577 11.0838 162.95 10.7096 162.95 10.2481V6.55103C162.95 6.08949 162.577 5.71533 162.116 5.71533Z",
    fill: "url(#paint102_linear_6391_340898)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M177.74 6.80554H167.544C167.272 6.80554 167.053 7.02572 167.053 7.29733V9.55683C167.053 9.82844 167.272 10.0486 167.544 10.0486H177.74C178.011 10.0486 178.231 9.82844 178.231 9.55683V7.29733C178.231 7.02572 178.011 6.80554 177.74 6.80554Z",
    fill: "url(#paint103_linear_6391_340898)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M192.176 6.80554H181.98C181.709 6.80554 181.489 7.02572 181.489 7.29733V9.55683C181.489 9.82844 181.709 10.0486 181.98 10.0486H192.176C192.448 10.0486 192.667 9.82844 192.667 9.55683V7.29733C192.667 7.02572 192.448 6.80554 192.176 6.80554Z",
    fill: "url(#paint104_linear_6391_340898)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M152.307 11.0563C152.211 11.0563 152.118 11.0185 152.05 10.9428C151.916 10.7984 151.926 10.5748 152.067 10.4441L153.66 8.96187H150.055C149.859 8.96187 149.702 8.80367 149.702 8.60765C149.702 8.41162 149.859 8.25342 150.055 8.25342H154.563C154.707 8.25342 154.838 8.34284 154.892 8.47696C154.944 8.61109 154.91 8.76584 154.803 8.86558L152.551 10.96C152.482 11.0219 152.397 11.0529 152.311 11.0529L152.307 11.0563Z",
    fill: "url(#paint105_linear_6391_340898)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M154.563 8.96188C154.477 8.96188 154.395 8.93093 154.326 8.87247L152.074 6.83652C151.93 6.70583 151.916 6.48229 152.05 6.33785C152.18 6.1934 152.403 6.17965 152.548 6.31033L154.8 8.34628C154.944 8.47697 154.958 8.70051 154.824 8.84495C154.755 8.92405 154.659 8.96188 154.559 8.96188H154.563Z",
    fill: "url(#paint106_linear_6391_340898)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M158.696 7.01533C158.841 6.93967 158.961 6.89496 159.122 6.96031C159.702 7.19416 160.293 7.41083 160.876 7.63781C160.966 7.6722 161.034 7.66532 161.113 7.61718C161.312 7.49681 161.515 7.38332 161.714 7.26982C161.917 7.15289 162.136 7.20448 162.236 7.38332C162.339 7.57247 162.263 7.78225 162.051 7.8923C161.213 8.31875 160.375 8.7452 159.541 9.17509C159.386 9.25419 159.246 9.26451 159.088 9.16821C158.823 9.00657 158.549 8.86557 158.264 8.70737C158.353 8.64891 158.429 8.59044 158.508 8.54573C158.535 8.52854 158.583 8.52854 158.617 8.53886C158.796 8.58356 158.974 8.63171 159.156 8.67642C159.191 8.6833 159.239 8.69018 159.266 8.67298C159.596 8.48727 159.922 8.29812 160.265 8.10209C159.737 7.73754 159.218 7.37988 158.693 7.01877L158.696 7.01533Z",
    fill: "url(#paint107_linear_6391_340898)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M158.267 10.0039V9.77002H162.281V10.0039H158.267Z",
    fill: "url(#paint108_linear_6391_340898)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M197.051 16.6172H147.219V26.2673H197.051V16.6172Z",
    fill: "url(#paint109_linear_6391_340898)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M162.116 18.7598H158.425C157.964 18.7598 157.591 19.1339 157.591 19.5955V23.2925C157.591 23.7541 157.964 24.1282 158.425 24.1282H162.116C162.577 24.1282 162.95 23.7541 162.95 23.2925V19.5955C162.95 19.1339 162.577 18.7598 162.116 18.7598Z",
    fill: "url(#paint110_linear_6391_340898)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M152.307 24.0973C152.221 24.0973 152.136 24.0663 152.067 24.0044L149.815 21.91C149.708 21.8103 149.674 21.6555 149.726 21.5214C149.777 21.3873 149.908 21.2979 150.055 21.2979H154.563C154.759 21.2979 154.916 21.4561 154.916 21.6521C154.916 21.8481 154.759 22.0063 154.563 22.0063H150.958L152.551 23.4886C152.695 23.6227 152.702 23.8462 152.568 23.9872C152.5 24.0629 152.403 24.1007 152.311 24.1007L152.307 24.0973Z",
    fill: "url(#paint111_linear_6391_340898)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M150.055 22.0029C149.959 22.0029 149.863 21.965 149.791 21.8859C149.66 21.7415 149.671 21.518 149.815 21.3873L152.067 19.3513C152.211 19.2206 152.434 19.231 152.565 19.3788C152.695 19.5233 152.685 19.7468 152.541 19.8775L150.289 21.9135C150.22 21.9754 150.138 22.0029 150.052 22.0029H150.055Z",
    fill: "url(#paint112_linear_6391_340898)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M158.696 20.0598C158.841 19.9841 158.961 19.9394 159.122 20.0047C159.702 20.2386 160.293 20.4553 160.876 20.6822C160.966 20.7166 161.034 20.7098 161.113 20.6616C161.312 20.5412 161.515 20.4277 161.714 20.3143C161.917 20.1973 162.136 20.2489 162.236 20.4277C162.339 20.6169 162.263 20.8267 162.051 20.9367C161.213 21.3632 160.375 21.7896 159.541 22.2195C159.386 22.2986 159.246 22.3089 159.088 22.2126C158.823 22.051 158.549 21.91 158.264 21.7518C158.353 21.6933 158.429 21.6349 158.508 21.5902C158.535 21.573 158.583 21.573 158.617 21.5833C158.796 21.628 158.974 21.6761 159.156 21.7209C159.191 21.7277 159.239 21.7346 159.266 21.7174C159.596 21.5317 159.922 21.3426 160.265 21.1465C159.737 20.782 159.218 20.4243 158.693 20.0632L158.696 20.0598Z",
    fill: "url(#paint113_linear_6391_340898)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M158.267 23.0449V22.811H162.281V23.0449H158.267Z",
    fill: "url(#paint114_linear_6391_340898)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M177.74 19.8466H167.544C167.272 19.8466 167.053 20.0667 167.053 20.3383V22.5978C167.053 22.8695 167.272 23.0896 167.544 23.0896H177.74C178.011 23.0896 178.231 22.8695 178.231 22.5978V20.3383C178.231 20.0667 178.011 19.8466 177.74 19.8466Z",
    fill: "url(#paint115_linear_6391_340898)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M192.176 19.8466H181.98C181.709 19.8466 181.489 20.0667 181.489 20.3383V22.5978C181.489 22.8695 181.709 23.0896 181.98 23.0896H192.176C192.448 23.0896 192.667 22.8695 192.667 22.5978V20.3383C192.667 20.0667 192.448 19.8466 192.176 19.8466Z",
    fill: "url(#paint116_linear_6391_340898)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M197.051 29.5414H147.219V39.1915H197.051V29.5414Z",
    fill: "url(#paint117_linear_6391_340898)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M152.307 37.0215C152.221 37.0215 152.136 36.9905 152.067 36.9286L149.815 34.8342C149.708 34.7345 149.674 34.5797 149.726 34.4456C149.777 34.3115 149.908 34.222 150.055 34.222H154.563C154.759 34.222 154.916 34.3802 154.916 34.5763C154.916 34.7723 154.759 34.9305 154.563 34.9305H150.958L152.551 36.4128C152.695 36.5469 152.702 36.7704 152.568 36.9114C152.5 36.9871 152.403 37.0249 152.311 37.0249L152.307 37.0215Z",
    fill: "url(#paint118_linear_6391_340898)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M150.055 34.9271C149.959 34.9271 149.863 34.8892 149.791 34.8101C149.66 34.6657 149.671 34.4422 149.815 34.3115L152.067 32.2755C152.211 32.1448 152.434 32.1551 152.565 32.303C152.695 32.4475 152.685 32.671 152.541 32.8017L150.289 34.8376C150.22 34.8996 150.138 34.9271 150.052 34.9271H150.055Z",
    fill: "url(#paint119_linear_6391_340898)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M168.525 33.7749H158.71C158.271 33.7749 157.914 33.4173 157.914 32.9771C157.914 32.5369 158.271 32.1792 158.71 32.1792H168.525C168.965 32.1792 169.322 32.5369 169.322 32.9771C169.322 33.4173 168.965 33.7749 168.525 33.7749Z",
    fill: "url(#paint120_linear_6391_340898)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M176.301 36.9665H158.713C158.274 36.9665 157.917 36.6088 157.917 36.1686C157.917 35.7284 158.274 35.3707 158.713 35.3707H176.301C176.741 35.3707 177.098 35.7284 177.098 36.1686C177.098 36.6088 176.741 36.9665 176.301 36.9665Z",
    fill: "url(#paint121_linear_6391_340898)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M152.307 -3.66663H151.497V3.57269H152.307V-3.66663Z",
    fill: "url(#paint122_linear_6391_340898)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M193.072 -3.66663H192.262V3.57269H193.072V-3.66663Z",
    fill: "url(#paint123_linear_6391_340898)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3258 47.7342C75.3258 44.3364 72.5758 41.5817 69.1839 41.5817C65.7919 41.5817 63.042 44.3364 63.042 47.7342C63.042 50.6953 65.1328 53.168 67.9136 53.7561C67.972 53.9349 68.0887 54.1413 68.2672 54.3717L68.8646 55.2384C69.0157 55.4585 69.3418 55.4585 69.4929 55.2384L70.0902 54.3717C70.2276 54.1722 70.4095 53.9453 70.6155 53.7183C73.314 53.0717 75.3224 50.6368 75.3224 47.7342H75.3258Z",
    fill: "url(#paint124_linear_6391_340898)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1838 53.2402C69.362 53.2402 69.5065 53.0954 69.5065 52.9169C69.5065 52.7384 69.362 52.5936 69.1838 52.5936C69.0056 52.5936 68.8611 52.7384 68.8611 52.9169C68.8611 53.0954 69.0056 53.2402 69.1838 53.2402Z",
    fill: "url(#paint125_linear_6391_340898)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6223 45.8462H68.6997V48.5803H70.6223V45.8462Z",
    fill: "url(#paint126_linear_6391_340898)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5325 53.6426H70.897C70.897 53.6426 70.9072 53.6426 70.9141 53.6392V48.6284L67.5325 46.7644V53.6426Z",
    fill: "url(#paint127_linear_6391_340898)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8112 48.061C70.7425 47.9028 70.6498 47.7687 70.54 47.6552C70.4301 47.5451 70.3031 47.4557 70.1658 47.38C70.0353 47.3113 69.898 47.2494 69.7607 47.1978C69.6268 47.1462 69.4997 47.098 69.3727 47.0533C69.256 47.0086 69.1496 46.9639 69.0569 46.9123C68.9745 46.8676 68.9127 46.816 68.8646 46.7541C68.8268 46.706 68.8097 46.6441 68.8097 46.5684C68.8097 46.5168 68.82 46.4721 68.8371 46.4343C68.8543 46.3965 68.8783 46.3689 68.9127 46.3414C68.9504 46.3105 69.0054 46.2864 69.0706 46.2692C69.2285 46.2245 69.4929 46.2279 69.6851 46.2795C69.7916 46.3105 69.8877 46.3414 69.9701 46.3758C70.0525 46.4102 70.1246 46.4412 70.1795 46.4721C70.3374 46.5547 70.4439 46.5512 70.5228 46.4962C70.564 46.4687 70.5949 46.4274 70.6155 46.3689C70.6292 46.3277 70.6395 46.2761 70.6464 46.2142C70.6498 46.1626 70.6533 46.0973 70.6533 46.0182C70.6533 45.9597 70.6533 45.9081 70.6498 45.8634C70.6498 45.8118 70.643 45.7671 70.6361 45.7327C70.6258 45.6846 70.6121 45.6467 70.5949 45.6158C70.5777 45.5814 70.5537 45.547 70.5194 45.5126C70.4851 45.4782 70.437 45.4473 70.3649 45.4129C70.3065 45.3854 70.2413 45.3578 70.1726 45.3338C70.1005 45.3097 70.025 45.2856 69.946 45.2684C69.922 45.2615 69.898 45.2581 69.874 45.2512L69.9323 44.701C69.9323 44.6563 69.9254 44.615 69.9117 44.5772C69.898 44.5325 69.8637 44.474 69.7813 44.4327C69.7366 44.4121 69.6851 44.3949 69.6199 44.3846C69.5169 44.3674 69.3315 44.3674 69.2354 44.3811C69.1805 44.388 69.1324 44.4018 69.0946 44.419C69.0431 44.443 69.0088 44.474 68.9813 44.5153C68.9607 44.5497 68.947 44.5875 68.9401 44.6322V44.6838C68.9058 44.9795 68.717 45.2375 68.4423 45.351L68.4046 45.3647C68.2226 45.4404 68.0647 45.5436 67.9377 45.6674C67.8072 45.7946 67.7076 45.9425 67.6424 46.111C67.5737 46.2795 67.5394 46.4652 67.5394 46.6647C67.5394 46.8848 67.5737 47.0774 67.639 47.239C67.7042 47.3972 67.7969 47.5382 67.9102 47.6517C68.0201 47.7618 68.1436 47.8546 68.281 47.9303C68.4114 48.0025 68.5453 48.0644 68.6792 48.116C68.8097 48.1676 68.9401 48.2157 69.0637 48.2605C69.177 48.3017 69.28 48.3499 69.3727 48.4015C69.4517 48.4462 69.5169 48.5012 69.5615 48.5597C69.5993 48.6044 69.6165 48.6663 69.6165 48.7454C69.6165 48.8692 69.5718 48.962 69.4757 49.0343C69.3658 49.1168 69.1873 49.1581 68.9436 49.1581C68.7788 49.1581 68.6346 49.1409 68.5144 49.1099C68.3908 49.0755 68.2844 49.0377 68.1986 48.9999C68.1093 48.9586 68.0407 48.9208 67.9823 48.8898C67.8175 48.7901 67.7042 48.797 67.6149 48.852C67.5669 48.8795 67.5291 48.9276 67.5051 48.9861C67.4879 49.0308 67.4742 49.0858 67.4673 49.1581C67.4605 49.2131 67.4604 49.2887 67.4604 49.3747C67.4604 49.4951 67.4673 49.5845 67.481 49.6498C67.4982 49.7358 67.536 49.8012 67.584 49.8528C67.6218 49.8906 67.6767 49.9284 67.7454 49.9662C67.8038 49.9972 67.8759 50.0282 67.9583 50.0591C68.0372 50.0901 68.1265 50.1176 68.226 50.1416C68.2775 50.1554 68.329 50.1657 68.3805 50.176L68.3222 50.7469C68.3119 50.8019 68.3153 50.857 68.3359 50.9051C68.3531 50.9464 68.3874 51.0049 68.4664 51.0427C68.5076 51.0633 68.5591 51.0771 68.6243 51.0874C68.6758 51.0943 68.7479 51.1012 68.8337 51.1012C68.9024 51.1012 68.9642 51.0977 69.0054 51.0908C69.0569 51.084 69.1015 51.0736 69.1393 51.0564C69.1942 51.0324 69.2354 50.998 69.2663 50.9533C69.2869 50.9189 69.2972 50.881 69.3041 50.8363V50.8088C69.3418 50.4615 69.5787 50.1829 69.9049 50.0591C69.9049 50.0591 69.9049 50.0591 69.9083 50.0591C70.1177 49.98 70.2962 49.8734 70.4473 49.7393C70.5983 49.6051 70.7185 49.4401 70.8009 49.2544C70.8833 49.0686 70.9245 48.8589 70.9245 48.6284C70.9245 48.4118 70.8902 48.2226 70.8215 48.0644L70.8112 48.061Z",
    fill: "url(#paint128_linear_6391_340898)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6391_340898",
    x1: 15.4999,
    y1: 78,
    x2: 200,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152357,
    stopColor: "#FFFCE2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480568,
    stopColor: "#FFEB85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6391_340898",
    x1: 10,
    y1: -8.85996,
    x2: 202.973,
    y2: 169.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676454,
    stopColor: "#BCF4EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6391_340898",
    x1: 34.4577,
    y1: 20.0357,
    x2: 34.4577,
    y2: 26.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6391_340898",
    x1: 191.002,
    y1: 44.2539,
    x2: 191.002,
    y2: 50.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6391_340898",
    x1: 140.202,
    y1: 0.494665,
    x2: 140.202,
    y2: 9.82152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6391_340898",
    x1: 105.328,
    y1: 70.962,
    x2: 215,
    y2: 70.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6391_340898",
    x1: 159.63,
    y1: 15.2553,
    x2: 10,
    y2: 15.2553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6391_340898",
    x1: 10,
    y1: 22.8386,
    x2: 215,
    y2: 22.8386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6391_340898",
    x1: 10,
    y1: 109.191,
    x2: 215,
    y2: 109.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6391_340898",
    x1: 10,
    y1: 84.9076,
    x2: 215,
    y2: 84.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6391_340898",
    x1: 94.136,
    y1: -28.2459,
    x2: 273.607,
    y2: 85.3415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6391_340898",
    x1: 10.9098,
    y1: 12.308,
    x2: 66.0155,
    y2: 141.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6391_340898",
    x1: 141.788,
    y1: 40.3849,
    x2: 143.028,
    y2: 40.3849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6391_340898",
    x1: 59.8494,
    y1: 25.9269,
    x2: 239.32,
    y2: 139.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6391_340898",
    x1: 79.9126,
    y1: -5.77483,
    x2: 259.383,
    y2: 107.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6391_340898",
    x1: 58.3215,
    y1: 28.3411,
    x2: 237.792,
    y2: 141.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6391_340898",
    x1: 50.7274,
    y1: 88.0612,
    x2: 291.987,
    y2: 189.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6391_340898",
    x1: 230.573,
    y1: 157.435,
    x2: 89.6474,
    y2: 77.8708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6391_340898",
    x1: 112.5,
    y1: 107.258,
    x2: 112.5,
    y2: 84.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6391_340898",
    x1: 8.53061,
    y1: 125.874,
    x2: 93.7048,
    y2: 103.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6391_340898",
    x1: 10.4669,
    y1: 139.156,
    x2: 38.9688,
    y2: 111.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6391_340898",
    x1: 58.4829,
    y1: 123.326,
    x2: 134.575,
    y2: 123.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6391_340898",
    x1: 103.807,
    y1: 133.041,
    x2: 179.69,
    y2: 115.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6391_340898",
    x1: 18.6138,
    y1: 123.79,
    x2: 96.1308,
    y2: 123.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6391_340898",
    x1: 85.9823,
    y1: 117.276,
    x2: 110.819,
    y2: 111.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E8B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6391_340898",
    x1: 94.6716,
    y1: 89.0344,
    x2: 103.533,
    y2: 89.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6391_340898",
    x1: 94.3489,
    y1: 83.5181,
    x2: 103.814,
    y2: 83.5181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6391_340898",
    x1: 81.1965,
    y1: 101.164,
    x2: 116.699,
    y2: 101.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6391_340898",
    x1: 83.5276,
    y1: 113.92,
    x2: 86.947,
    y2: 113.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6391_340898",
    x1: 110.787,
    y1: -3.66672,
    x2: 114.206,
    y2: -3.66672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6391_340898",
    x1: 97.4147,
    y1: 73.3486,
    x2: 99.7643,
    y2: 124.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6391_340898",
    x1: 115.658,
    y1: 58.9733,
    x2: 115.658,
    y2: 88.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6391_340898",
    x1: 109.427,
    y1: 54.9976,
    x2: 121.848,
    y2: 54.9976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6391_340898",
    x1: 101.253,
    y1: 96.8688,
    x2: 129.858,
    y2: 96.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6391_340898",
    x1: 101.253,
    y1: 109.064,
    x2: 129.858,
    y2: 109.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6391_340898",
    x1: 104.597,
    y1: 114.061,
    x2: 108.016,
    y2: 114.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6391_340898",
    x1: 123.29,
    y1: 114.061,
    x2: 126.71,
    y2: 114.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6391_340898",
    x1: 101.301,
    y1: 78.7928,
    x2: 115.258,
    y2: 93.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6391_340898",
    x1: 114.807,
    y1: 72.5543,
    x2: 117.16,
    y2: 123.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6391_340898",
    x1: 102.626,
    y1: 92.759,
    x2: 103.715,
    y2: 92.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6391_340898",
    x1: 106.317,
    y1: 93.7874,
    x2: 124.794,
    y2: 93.7874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6391_340898",
    x1: 115.291,
    y1: 72.5304,
    x2: 117.644,
    y2: 123.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6391_340898",
    x1: 108.044,
    y1: 90.9706,
    x2: 109.132,
    y2: 90.9706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6391_340898",
    x1: 113.544,
    y1: 99.4584,
    x2: 124.471,
    y2: 99.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6391_340898",
    x1: 114.567,
    y1: 100.122,
    x2: 123.393,
    y2: 100.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6391_340898",
    x1: 115.487,
    y1: 100.903,
    x2: 120.685,
    y2: 100.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6391_340898",
    x1: 119.734,
    y1: 98.2479,
    x2: 121.958,
    y2: 98.2479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6391_340898",
    x1: 117.917,
    y1: 101.013,
    x2: 127.081,
    y2: 101.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6391_340898",
    x1: 118.669,
    y1: 101.553,
    x2: 126.126,
    y2: 101.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6391_340898",
    x1: 121.285,
    y1: 100.556,
    x2: 123.51,
    y2: 100.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6391_340898",
    x1: 122.212,
    y1: 101.013,
    x2: 124.437,
    y2: 101.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6391_340898",
    x1: 123.208,
    y1: 101.553,
    x2: 125.433,
    y2: 101.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6391_340898",
    x1: 114.072,
    y1: 72.5885,
    x2: 116.425,
    y2: 123.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6391_340898",
    x1: 102.626,
    y1: 106.894,
    x2: 103.715,
    y2: 106.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6391_340898",
    x1: 104.37,
    y1: 106.894,
    x2: 105.458,
    y2: 106.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6391_340898",
    x1: 107.707,
    y1: 79.6078,
    x2: 123.393,
    y2: 79.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6391_340898",
    x1: 70.3823,
    y1: 60.3248,
    x2: 65.6585,
    y2: 66.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6391_340898",
    x1: 47.7921,
    y1: 101.395,
    x2: 76.6064,
    y2: 101.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6391_340898",
    x1: 48.743,
    y1: 70.5355,
    x2: 42.2508,
    y2: 58.6766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6391_340898",
    x1: 38.2891,
    y1: 76.8497,
    x2: 93.2881,
    y2: 76.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6391_340898",
    x1: 49.5533,
    y1: 101.274,
    x2: 82.8719,
    y2: 101.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6391_340898",
    x1: 63.7838,
    y1: 77.8987,
    x2: 119.253,
    y2: 77.8987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6391_340898",
    x1: 59.6743,
    y1: 62.5191,
    x2: 47.6587,
    y2: 42.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6391_340898",
    x1: 49.4642,
    y1: 64.4793,
    x2: 65.2704,
    y2: 64.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6391_340898",
    x1: 54.8608,
    y1: 71.2303,
    x2: 87.2114,
    y2: 71.2303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6391_340898",
    x1: 45.7048,
    y1: 52.4218,
    x2: 52.4063,
    y2: 52.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6391_340898",
    x1: 43.8303,
    y1: 65.628,
    x2: 62.8533,
    y2: 65.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6391_340898",
    x1: 50.9643,
    y1: 53.9419,
    x2: 49.6245,
    y2: 49.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6391_340898",
    x1: 46.9751,
    y1: 44.4189,
    x2: 56.4952,
    y2: 44.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_6391_340898",
    x1: 59.5061,
    y1: 47.3044,
    x2: 57.0782,
    y2: 46.6393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_6391_340898",
    x1: 87.4482,
    y1: 79.2331,
    x2: 87.9167,
    y2: 83.8929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_6391_340898",
    x1: 82.4117,
    y1: 84.5465,
    x2: 86.9504,
    y2: 84.5465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_6391_340898",
    x1: 87.0948,
    y1: 86.0082,
    x2: 95.6811,
    y2: 86.0082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_6391_340898",
    x1: 95.1866,
    y1: 81.7162,
    x2: 86.6436,
    y2: 85.4368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_6391_340898",
    x1: 94.2941,
    y1: 83.3669,
    x2: 91.4288,
    y2: 84.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_6391_340898",
    x1: 118.615,
    y1: 74.3771,
    x2: 122.957,
    y2: 74.3771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_6391_340898",
    x1: 119.614,
    y1: 78.1017,
    x2: 122.848,
    y2: 78.1017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_6391_340898",
    x1: 118.402,
    y1: 70.9896,
    x2: 122.94,
    y2: 70.9896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_6391_340898",
    x1: 125.35,
    y1: 77.8849,
    x2: 121.093,
    y2: 75.4289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_6391_340898",
    x1: 119.253,
    y1: 69.9028,
    x2: 120.224,
    y2: 71.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_6391_340898",
    x1: 41.5986,
    y1: 65.2187,
    x2: 63.9759,
    y2: 65.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_6391_340898",
    x1: 148.047,
    y1: 80.7428,
    x2: 93.4836,
    y2: 78.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_6391_340898",
    x1: 47.1021,
    y1: 55.1181,
    x2: 52.9178,
    y2: 55.1181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_6391_340898",
    x1: 91.5062,
    y1: 76.0279,
    x2: 67.3982,
    y2: 70.6806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_6391_340898",
    x1: 35.7109,
    y1: 62.9489,
    x2: 45.0113,
    y2: 62.9489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_6391_340898",
    x1: 44.5342,
    y1: 44.1611,
    x2: 54.0302,
    y2: 44.1611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_6391_340898",
    x1: 48.8049,
    y1: 43.4664,
    x2: 52.9728,
    y2: 43.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_6391_340898",
    x1: 66.8289,
    y1: 56.1463,
    x2: 32.279,
    y2: 31.7783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_6391_340898",
    x1: 33.1017,
    y1: 53.8834,
    x2: 39.3225,
    y2: 53.8834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_6391_340898",
    x1: 85.6768,
    y1: 45.2891,
    x2: 73.5525,
    y2: 75.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_6391_340898",
    x1: 44.9631,
    y1: 95.7751,
    x2: 95.7943,
    y2: 95.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_6391_340898",
    x1: 41.5988,
    y1: 60.9611,
    x2: 49.0968,
    y2: 60.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_6391_340898",
    x1: 66.1388,
    y1: 65.0743,
    x2: 60.989,
    y2: 71.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_6391_340898",
    x1: 142.334,
    y1: 82.0222,
    x2: 180.188,
    y2: 82.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_6391_340898",
    x1: 135.451,
    y1: 76.8498,
    x2: 190.453,
    y2: 76.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_6391_340898",
    x1: 145.87,
    y1: 101.274,
    x2: 179.189,
    y2: 101.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_6391_340898",
    x1: 132.944,
    y1: 95.7751,
    x2: 183.779,
    y2: 95.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_6391_340898",
    x1: 151.497,
    y1: 16.8477,
    x2: 152.307,
    y2: 16.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_6391_340898",
    x1: 192.262,
    y1: 16.8477,
    x2: 193.072,
    y2: 16.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_6391_340898",
    x1: 151.497,
    y1: 29.8887,
    x2: 152.307,
    y2: 29.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_6391_340898",
    x1: 192.262,
    y1: 29.8887,
    x2: 193.072,
    y2: 29.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_6391_340898",
    x1: 147.219,
    y1: 8.40126,
    x2: 197.051,
    y2: 8.40126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_6391_340898",
    x1: 157.591,
    y1: 8.40127,
    x2: 162.95,
    y2: 8.40127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_6391_340898",
    x1: 167.053,
    y1: 8.42536,
    x2: 178.231,
    y2: 8.42536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_6391_340898",
    x1: 181.489,
    y1: 8.42536,
    x2: 192.667,
    y2: 8.42536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_6391_340898",
    x1: 148.191,
    y1: 9.72536,
    x2: 160.859,
    y2: 9.42034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_6391_340898",
    x1: 148.143,
    y1: 7.71693,
    x2: 160.811,
    y2: 7.41191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_6391_340898",
    x1: 158.267,
    y1: 8.08145,
    x2: 162.281,
    y2: 8.08145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_6391_340898",
    x1: 158.267,
    y1: 9.88695,
    x2: 162.281,
    y2: 9.88695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_6391_340898",
    x1: 147.219,
    y1: 21.4423,
    x2: 197.051,
    y2: 21.4423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_6391_340898",
    x1: 9.99984,
    y1: 21.4423,
    x2: 10.3432,
    y2: 21.4423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_6391_340898",
    x1: 148.352,
    y1: 22.5291,
    x2: 158.23,
    y2: 22.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_6391_340898",
    x1: 147.745,
    y1: 20.7098,
    x2: 158.981,
    y2: 20.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_6391_340898",
    x1: 158.267,
    y1: 21.1259,
    x2: 162.281,
    y2: 21.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_6391_340898",
    x1: 158.267,
    y1: 22.928,
    x2: 162.281,
    y2: 22.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_6391_340898",
    x1: 167.053,
    y1: 21.4698,
    x2: 178.231,
    y2: 21.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_6391_340898",
    x1: 181.489,
    y1: 21.4698,
    x2: 192.667,
    y2: 21.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_6391_340898",
    x1: 140.336,
    y1: 34.3664,
    x2: 209.782,
    y2: 34.3664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_6391_340898",
    x1: 150.488,
    y1: 35.6424,
    x2: 156.252,
    y2: 35.4745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_6391_340898",
    x1: 150.426,
    y1: 33.5755,
    x2: 156.194,
    y2: 33.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_6391_340898",
    x1: 157.917,
    y1: 32.9771,
    x2: 169.322,
    y2: 32.9771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_6391_340898",
    x1: 157.917,
    y1: 36.1686,
    x2: 177.098,
    y2: 36.1686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_6391_340898",
    x1: 151.497,
    y1: -0.0452468,
    x2: 152.307,
    y2: -0.0452468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_6391_340898",
    x1: 192.262,
    y1: -0.0452468,
    x2: 193.072,
    y2: -0.0452468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_6391_340898",
    x1: 69.1839,
    y1: 56.4592,
    x2: 69.1839,
    y2: 43.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_6391_340898",
    x1: 69.1838,
    y1: 54.4439,
    x2: 69.1838,
    y2: 50.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F19169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_6391_340898",
    x1: 69.6576,
    y1: 52.4871,
    x2: 69.6576,
    y2: 45.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_6391_340898",
    x1: 69.2216,
    y1: 57.1539,
    x2: 69.2216,
    y2: 46.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_6391_340898",
    x1: 69.1839,
    y1: 52.8035,
    x2: 69.1839,
    y2: 19.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CAE0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9FB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6391_340898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 136.667,
    fill: "white",
    transform: "translate(10 -3.66663)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCardBackground);
export default __webpack_public_path__ + "static/media/account-card-background.ef7da555ae70dfe065d4a185e3b19454.svg";
export { ForwardRef as ReactComponent };